import { render, staticRenderFns } from "./Standing.vue?vue&type=template&id=201d0503&lang=pug"
import script from "./Standing.vue?vue&type=script&lang=js"
export * from "./Standing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports